export const SOUND_SETTINGS_LS_KEY = 'soundSettings';
export const CUSTOM_STRATEGY_LS_KEY = 'customPokerStrategy';
export const SHORTCUT_CONFIG_LS_KEY = 'pokerGameShortcutConfig';
export const HIGH_SCORE_LS_KEY = 'highScore';
